import { Box, Grid, MenuItem, Typography } from "@mui/material";
import { memo, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Label from "../../../components/label";
import CustomDropDown from "../../../components/select";
import TextInput from "../../../components/textInput";
import { AppContext } from "../../../lib/Context";
import { getAllEquipment } from "../../../services/EquipmentApi";
import { handleOpenSnackBar } from "../../../utils/helper";

const COST_TYPE = [
  { value: "One Of Cost", type: "oneOfCost" },
  { value: "Monthly", type: "monthly" },
];

const OTHER = [
  "Wifi Extender Basic",
  "Wifi Extender Advanced",
  "ATA Device",
  "Other",
];

const Equipments = () => {
  const location = useLocation();
  const { equipments, setEquipments, userData } = useContext(AppContext);
  const isDetailPage = location.pathname === "/prospect-details";
  const [isLoading, setIsLoading] = useState(false);
  const [allEquipments, setAllEquipments] = useState([]);

  useEffect(() => {
    fetchAllEquipment();
  }, []);

  const fetchAllEquipment = async () => {
    try {
      setIsLoading(true);
      const response = await getAllEquipment();
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setAllEquipments(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const renderPrice = (equipments) => {
    if (equipments?.costType === "monthly") {
      return (
        allEquipments?.find(
          (x) =>
            x.value?.toLowerCase()?.trim() ===
            equipments?.type?.toLowerCase()?.trim()
        )?.monthlyPrice || 0
      );

      // if (equipments?.type === "Wifi Extender Basic") return 1.5;
      // if (equipments?.type === "Wifi Extender Advanced") return 5;
      // if (equipments?.type === "ATA Device") return 1.5;
    }

    if (equipments?.costType === "oneOfCost") {
      return (
        allEquipments?.find((x) => {
          return (
            x.value?.toLowerCase()?.trim() ===
            equipments?.type?.toLowerCase()?.trim()
          );
        })?.oneOffCostPrice || 0
      );

      // if (equipments?.type === "Wifi Extender Basic") return 20;
      // if (equipments?.type === "Wifi Extender Advanced") return 80;
      // if (equipments?.type === "ATA Device") return 30;
    }
    return 0;
  };

  return (
    <Box mt={2} mb={5}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        Other Equipment
      </Typography>

      <Grid container mt={0} spacing={2}>
        {/* Cost Type Dropdown */}
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Cost Type"} />
          <CustomDropDown
            variant="filled"
            value={equipments.costType}
            onChange={(e) =>
              setEquipments((prev) => ({
                ...prev,
                costType: e.target.value,
                price: 0,
                type: "",
                value: "",
                name: "",
              }))
            }
            readonly={isDetailPage}
          >
            {COST_TYPE.map((val, ind) => (
              <MenuItem key={ind} value={val.type}>
                {val.value}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid>

        {/* Equipment Type Dropdown */}
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Other Equipment"} />
          <CustomDropDown
            variant="filled"
            value={equipments.type}
            onChange={(e) => {
              const newType = e.target.value;
              const newName = allEquipments?.find((x) => x.value === newType)?.name;
              setEquipments((prev) => ({
                ...prev,
                value: newType === "Other" ? "" : newType,
                type: newType,
                price: renderPrice({ ...prev, type: newType }),
                name: newName,
              }));
            }}
            readonly={isDetailPage}
          >
            <MenuItem value="" disabled>
              Select Option
            </MenuItem>
            {allEquipments?.map((val, ind) => (
              <MenuItem key={ind} value={val.value}>
                {val.name}
              </MenuItem>
            ))}
            <MenuItem value="Other">Other</MenuItem>
          </CustomDropDown>
        </Grid>

        {/* Custom Equipment Input Field */}
        {equipments?.type === "Other" && (
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Other Equipment"} htmlFor="other-equipment" />
            <TextInput
              id="other-equipment"
              required
              type="text"
              variant="filled"
              value={equipments.value}
              name="value"
              onChange={(e) =>
                setEquipments((prev) => ({ ...prev, value: e.target.value }))
              }
              readonly={isDetailPage}
            />
          </Grid>
        )}

        {/* Total Cost Input Field */}
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Total Cost"} htmlFor="equipment-cost" />
          <TextInput
            id="equipment-cost"
            required
            type="number"
            variant="filled"
            value={equipments.price}
            name="price"
            onChange={(e) => {
              let price = parseFloat(e.target.value);
              if (price < 0) return;
              setEquipments((prev) => ({ ...prev, price }));
            }}
            readonly={isDetailPage}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default memo(Equipments);
